import { useEffect, useMemo, useState } from "react";
import { fetchExtracts, extractGenreLabel } from "../lib/api";
import { StoryCard } from "../components/StoryCard";

export default function Histoires() {
  const [stories, setStories] = useState(null);
  const [genre, setGenre] = useState("all");
  useEffect(() => { fetchExtracts().then(setStories).catch(() => setStories([])); document.title = "Histoires offertes | CLED"; }, []);
  const genres = useMemo(() => [...new Set((stories || []).map((s) => s.genre).filter(Boolean))], [stories]);
  const shown = (stories || []).filter((s) => genre === "all" || s.genre === genre);

  return (
    <div data-testid="page-histoires" className="pt-40 pb-24 px-6 md:px-12 lg:px-24 min-h-screen">
      <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-4">Distributeur d'extraits littéraires CLED</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-[#1A1A1A] leading-tight mb-6">Histoires offertes</h1>
      <p className="font-body text-[#4A4A4A] max-w-2xl mb-12">Des extraits de nos livres à lire ou écouter gratuitement en quelques minutes. Scannez nos QR codes chez nos partenaires, ou lisez-les directement ici.</p>
      {genres.length > 1 && (
        <div className="flex flex-wrap gap-2 mb-10" data-testid="stories-genre-filters">
          {["all", ...genres].map((g) => (
            <button key={g} onClick={() => setGenre(g)} data-testid={`stories-filter-${g}`} className={`px-4 py-2 text-xs font-body border transition-colors ${genre === g ? "bg-[#1A1A1A] text-[#FAF9F6] border-[#1A1A1A]" : "border-[#D1CFC7] text-[#4A4A4A] hover:border-[#1A1A1A]"}`}>
              {g === "all" ? "Toutes" : extractGenreLabel(g)}
            </button>
          ))}
        </div>
      )}
      {stories === null ? (
        <p className="font-body text-[#757575]">Chargement…</p>
      ) : shown.length === 0 ? (
        <p data-testid="stories-empty" className="font-body text-[#757575]">Aucune histoire disponible pour le moment.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {shown.map((s, i) => <StoryCard key={s.id} story={s} index={i} />)}
        </div>
      )}
    </div>
  );
}
